import React from 'react';
import Utils from '../shared/Utils';

const TableHead = ({ type }) => (
  <thead className='thead-inverse'>
    <tr className='table-row'>
      <th className='table-cell' children={Utils.t('results.rank')} />
      {type === 'individuals' && (
        <th className='table-cell' children={Utils.t('results.name')} />
      )}

      <th className='table-cell' children={Utils.t('results.school')} />
      <th className='table-cell' children={Utils.t('results.score')} />
    </tr>
  </thead>
);

const ResultCell = ({ is_admin, edit_mode, result, onChange }) => {
  if (!is_admin || !edit_mode) {
    return <td className='table-cell historical-result' children={result.score} />
  }

  return (
    <input
      className='historical-result-editable text-center'
      defaultValue={result.score}
      onChange={(e) => onChange(e, result.id) }
    />
  );
};

const TableBody = ({ results, type, determineRank, getSchoolName, ...props }) => {
  if (!results) return null;
  let rank = 1;

  return (
    <tbody className='table-body'>
      {results.map((result, index) => {
        rank = determineRank(rank, index);
        const fullName = `${result.first_name} ${result.last_name}`;

        return (
          <tr className='table-row' key={`table-row-${index}`}>
            <td className='table-cell' children={rank} />
            {type === 'individuals' && (
              <td className='table-cell' children={fullName} />
            )}

            <td className='table-cell' children={getSchoolName(result)} />
            <ResultCell {...props} result={result} />
          </tr>
        );
      })}
    </tbody>
  );
};

class ResultsTable extends React.PureComponent {
  determineRank = (rank, index) => {
    if (index === 0) return 1;

    const { results } = this.props;
    const currentScore = results[index].score;
    const previousScore = results[index - 1].score;
    if (currentScore === previousScore) return rank;

    return index + 1;
  }

  onChange = (e, resultId) => {
    const { handleChange } = this.props;
    const newScore = parseInt(e.target.value);
    handleChange(resultId, newScore);
  }

  getSchoolName = (result) => {
    // If the school somehow gets deleted, we should
    // fallback on the school_name saved on the HistoricalRecord
    return result.school.name || result.school_name;
  }

  render() {
    const { type } = this.props;

    return (
      <table className='table table-striped table-bordered'>
        <TableHead type={type} />

        <TableBody
          {...this.props}
          determineRank={this.determineRank}
          onChange={this.onChange}
          getSchoolName={this.getSchoolName}
        />
      </table>
    );
  }
}

export default ResultsTable;
